import type { Tone } from '@/modules/agents/utils/agentStatusLabels';
import styles from './AgentStatus.module.css';

export const TONE_CLASS: Record<Tone, string> = {
  success: styles.toneSuccess,
  warning: styles.toneWarning,
  error: styles.toneError,
  info: styles.toneInfo,
  muted: styles.toneMuted,
  accent: styles.toneAccent,
};
